import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Gender: [],
  UserRoles: [],
  error: null,
};

export const looupDropdownSlice = createSlice({
  name: "getUsers",
  initialState,
  reducers: {
    getDropData: (state, action) => {
      ;
      if (action.payload.type === "gender") {
        state.Gender = action.payload;
      } else if (action.payload.type === "user_roles") {
        state.UserRoles = action.payload;
      } else if (action.payload.type === "error") {
        state.error = action.payload;
      }
    },
  },
});

export const { getDropData } = looupDropdownSlice.actions;
